import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { baseColors } from '@ncr-retail/mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const baseColor = baseColors();

export const styles = makeStyles(() => ({
  productNameContainer: {
    justifyContent: 'flex-start',
    paddingLeft: '0.975vw',
    paddingRight: '0.975vw',
    fontSize: rem(1),
    color: baseColor.palesky,
  },
  itemCodeContainer: {
    justifyContent: 'flex-start',
    color: baseColor.palesky,
  },
  productInformation: {
    fontSize: rem(1),
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  priceInformation: {
    fontSize: rem(1),
    textAlign: 'start',
    paddingLeft: '3.525vw',
    width: '100%',
    color: '#5D6B72',
  },
  itemContainer: {
    paddingBottom: '1vh',
  },
}));
